export const HeaderData = [
  {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
    heading: "Get Everything About Us",
  },
  {
    title: "Service",
    path: "#",
    subNav: [
      {
        subTitle: "Our Services",
        heading: " We serve you since 2000 ",
        path: "/Home/Our_Services",
      },
      {
        subTitle: "Services Lists",
        heading: " We serve you since 2000 ",
        path: "/Home/Services_Lists",
      },
      {
        subTitle: "Service Details",
        heading: "We do better plumbing work",
        path: "/Home/Our_Services/Service_Details",
      },
    ],
  },
  {
    title: "Other Pages",
    path: "#",
    subNav: [
      {
        subTitle: "Our Team",
        heading: "Our successful team",
        path: "/Home/Our_Team",
      },
      {
        subTitle: "Testimonial",
        heading: "Clients review",
        path: "/Home/Testimonial",
      },
      {
        subTitle: "Projects",
        heading: "Our work gallery",
        path: "/Home/Projects",
      },
      {
        subTitle: "Projects Details",
        heading: "Our work gallery",
        path: "/Home/Projects/Projects_Details",
      },
      {
        subTitle: "FAQ",
        heading: "Questions and answer",
        path: "/Home/FAQ",
      },
      {
        subTitle: "Error 404",
        heading: "Error_404",
        path: "/Home/Error_404",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        path: "/Home/Comming_Soon",
      },
      
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Our Blogs",
        heading: "Latest news and blogs ",
        path: "/Home/Our_Blogs",
      },
      
      {
        subTitle: "Blog Details",
        heading: "When have a problem with cracked pipes",
        path: "/Home/Our_Blogs/Blog_Details",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/Home/Contact_Us",
    heading: "Let's keep in touch",
  },
  {
    title: "Quote Request",
    heading: "Book an Appointment",
    path: "/Home/Quote_Request",
  },
];
